import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    background-color: #171850;
    text-align: center;
    padding: 70px 60px 0 60px;

    @media (max-width: 768px) {
        padding: 40px 20px 40px 20px;
    }
`

export const ContainerInterno = styled.div`
    display: inline-block;
    max-width: 1436px;
`

export const TituloPrincipal = styled.span`
    float: left;
    width: 100%;
    color: #FFFFFF;
    font-size: 30px;
    line-height: 40px;
    font-weight: 900;
    margin: 0 0 15px 0;

    strong {
        color: #EDC748;
    }

    @media (max-width: 768px) {
        font-size: 22px;
        line-height: 32px;

        br {
            display: none;
        }
    }
`

export const SubtituloBloco = styled.span`
    float: left;
    width: 100%;
    color: #C3C9E6;
    font-size: 16px;
    line-height: 26px;
    font-weight: 700;
    margin: 0 0 50px 0;

    strong {
        color: #FFFFFF;
    }

`

export const ListaPlanos = styled.div`
    float: left;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;

    @media (max-width: 1400px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 600px) {
        grid-template-columns: repeat(1, 1fr);
    }
`

export const ItemPlano = styled.div`
    
`

export const TagMelhorOferta = styled.div`
    display: flex;
    flex-direction: column;
    float: left;
    width: 100%;
    align-items: center;
    margin-bottom: 15px;
    min-height: 48px;

    @media (max-width: 768px) {
        min-height: 1px;
    }
`

export const TagMelhorOfertaIcone = styled.img`
    display: inline-block;
`

export const TagMelhorOfertaTexto = styled.span`
    color: #EDC748;
    font-size: 14px;
    font-weight: 600;
    margin-top: 5px;
`

export const BoxBorda = styled.div`
    float: left;
    width: 100%;
    border: solid 1px #DF9A30;
    border-radius: 16px;
    padding: 10px;
    background-color: #FAFAFA;
`

export const TagEconomia = styled.span`
    float: left;
    width: 100%;
    background-color: ${props => props.premium ? '#DF9A30' : '#E7B559'};
    color: #0F1A2A;
    text-align: center;
    border-radius: 8px;
    padding: 10px;
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 20px 0;
`

export const TituloCard = styled.span`
    float: left;
    width: 100%;
    color: #191919;
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 20px 0;
`

export const ListaBonus = styled.ul`
    float: left;
    width: 100%;
    margin: 0 0 20px 0;
    padding: 0;
    min-height: 40px;

    @media (max-width: 500px) {
        min-height: 1px;
    }
`

export const ListaBonusLi = styled.li`
    float: left;
    width: 100%;
    color: #575757;
    list-style: none;
    font-size: 13px;
    line-height: 20px;
`

export const PrecoDe = styled.span`
    float: left;
    width: 100%;
    color: #434343;
    text-decoration: line-through;
    margin: 0 0 10px 0;
    font-size: 15px;
`

export const PrecoPor = styled.span`
    float: left;
    width: 100%;
    color: #191919;
    margin: 0 0 20px 0;
    font-size: 26px;
    font-weight: 700;
`

export const LinkCartao = styled.a`
    float: left;
    width: 100%;
    border-radius: 4px;
    padding: 10px 10px;
    color: #191919;
    border: solid 2px ${props => props.premium ? '#DF9A30' : '#E7B559'};
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 7px;
`

export const LinkBoleto = styled.a`
    float: left;
    width: 100%;
    border-radius: 4px;
    padding: 10px 10px;
    color: #0F1A2A;
    background-color: ${props => props.premium ? '#DF9A30' : '#E7B559'};
    font-size: 13px;
    font-weight: 600;
`